<template>
  <ModalDefault modal_id="showStatusesTicketModal"
                size="modal-lg"
                header="y"
                :modal_header="titleModalMobile"
                icon=""
                class_header=""
                :style_top_header="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; top: 0; width: 100%; z-index: 999;' : ''"
                :style_footer="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; bottom: 0; width: 100%; z-index: 999;' : ''"
                class_footer="border-top"
                :lead_id="tickets.ticket.lead_id"
                class_body="p-0 "
                footer="">
    <div slot="body" :style="($mq === 'mobile' || $mq === 'tablet') ? 'padding-top: 110px;' : ''">
      <!-- Vide componente ModalDefault-->
      <div :style="($mq === 'mobile' || $mq === 'tablet') ? 'min-height: 85vh;' : 'min-height: 500px; max-height: 500px;'" style="overflow-y: auto;" class="card-body">
          <div class="px-2 py-2">
            <TicketStatuses :data="tickets.ticket_statuses"/>
          </div>
      </div>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-between cursor_default text-left py-2 ellipsis pl-4 pr-3"></div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import TicketStatuses from "../general/TicketStatuses";
import $ from "jquery";

export default {
  name: "ModalShowStatusesTicket",
  components: {
    TicketStatuses,
    ModalDefault
  },
  computed: {
    ...mapState(['users', 'tickets', 'me', 'configs']),
    ...mapGetters([
        'getLeadObject',
    ]),
    titleModalMobile(){
      if (this.$mq === 'mobile' || this.$mq === 'tablet'){
        return `${this.getLeadObject('id', this.tickets.ticket.lead_id).name ? this.getLeadObject('id', this.tickets.ticket.lead_id).name : '---'}`
      } else {
        return `${this.getLeadObject('id', this.tickets.ticket.lead_id).name ? this.getLeadObject('id', this.tickets.ticket.lead_id).name : '---'} - ${this.getLeadObject('id', this.tickets.ticket.lead_id).phone_hidden ? this.getLeadObject('id', this.tickets.ticket.lead_id).phone_hidden : '---'}`
      }
    }
  },
  mounted() {
    $('#showStatusesTicketModal').on('hidden.bs.modal', () => {
      this.tickets.ticket_statuses = []
    })
  },
  methods: {
    openUrl(payload){
      window.open(payload, "_blank");
    },
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>
<style scoped>
</style>
